var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.5507 76C46.1753 76 53.6288 73.7713 59.9684 69.5958C66.308 65.4204 71.2491 59.4856 74.1669 52.542C77.0847 45.5984 77.8482 37.9579 76.3607 30.5866C74.8732 23.2153 71.2016 16.4444 65.8102 11.13C60.4188 5.81558 53.5497 2.1964 46.0716 0.730166C38.5935 -0.736071 30.8422 0.0164926 23.798 2.89262C16.7538 5.76875 10.733 10.6393 6.49696 16.8883C2.26096 23.1374 0 30.4843 0 38C0 48.0782 4.06158 57.7436 11.2912 64.87C18.5209 71.9964 28.3264 76 38.5507 76Z",
    fill: "url(#paint0_linear_458_341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.8712 35.4615C52.8679 35.927 52.7149 36.3792 52.4349 36.7511C52.1549 37.1231 51.7628 37.3952 51.3163 37.5272L40.7717 40.7718L37.5268 51.3152C37.3946 51.7615 37.1224 52.1536 36.7505 52.4335C36.3785 52.7134 35.9264 52.8665 35.4609 52.87H35.4196C34.9631 52.8743 34.5168 52.7346 34.1442 52.4708C33.7716 52.207 33.4916 51.8326 33.344 51.4006L24.3613 27.1752C24.3584 27.1681 24.3561 27.1607 24.3544 27.1532C24.2201 26.7632 24.198 26.3434 24.2906 25.9415C24.3831 25.5396 24.5866 25.1717 24.8779 24.8797C25.1692 24.5877 25.5366 24.3833 25.9383 24.2898C26.3401 24.1963 26.76 24.2174 27.1503 24.3507L27.1724 24.3576L51.4017 33.3448C51.8404 33.4948 52.2196 33.7811 52.484 34.1619C52.7484 34.5427 52.8841 34.9981 52.8712 35.4615Z",
    fill: "#F8FAFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_341",
    x1: -9.97585,
    y1: -8,
    x2: 94.4299,
    y2: 0.934219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF4EDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7547CD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.79544353d8edb9ec0dc42bb32db0d323.svg";
export { ForwardRef as ReactComponent };